import { spaceToDash } from '@common/neo.tax';
import { AvatarTitleCell, Button, StyledTextLeftSpan, Tooltip } from '@ui-components/neo.tax';
import { CellProps, Column } from 'react-table';

import { useCurrentCompanyIdOptional } from '@neo.tax/shared/hooks';
import { GetCompaniesQueryCompany } from '@neo.tax/shared/hooks/useCompanies';
import { FilterSortDataType, getPath, Path } from '@neo.tax/shared/utils';

import { NavLinkTo } from '../navigate';
import { ColumnDefinition } from '../sort-popover';
import { CompanyStatus } from './CompanyStatus';

export const companyListColumns: Array<Column<GetCompaniesQueryCompany>> = [
  {
    id: 'select',
    accessor: (company): { id: string; name: string } => ({ id: company.id, name: company.shortName }),
    Cell: ({
      value,
    }: React.PropsWithChildren<CellProps<GetCompaniesQueryCompany, { id: string; name: string }>>): JSX.Element => {
      const currentCompanyId = useCurrentCompanyIdOptional();
      const companyNameWithoutSpace = spaceToDash(value.name);
      return (
        <Button
          disabled={currentCompanyId === value.id}
          size="base"
          variant="white"
          rounded="regular"
          as={NavLinkTo}
          id={`${companyNameWithoutSpace}-select-btn`}
          to={getPath({ path: Path.COMPANY, companyId: value.id })}
        >
          Select
        </Button>
      );
    },
  },
  {
    id: 'companyName',
    Header: 'Company Name',
    width: 'minmax(150px, 335px)',
    accessor: (company): string => company.shortName,
    Cell: ({ value }: React.PropsWithChildren<CellProps<GetCompaniesQueryCompany, string>>): JSX.Element => (
      <Tooltip text={value} anchorClassName="block overflow-hidden">
        <AvatarTitleCell title={value} size={6} fontSize="sm" fontWeight="normal" />
      </Tooltip>
    ),
  },
  {
    id: 'status',
    Header: (): JSX.Element => <StyledTextLeftSpan>Status</StyledTextLeftSpan>,
    width: 'minmax(150px, 275px)',
    accessor: (company): GetCompaniesQueryCompany => company,
    Cell: ({
      value,
    }: React.PropsWithChildren<CellProps<GetCompaniesQueryCompany, GetCompaniesQueryCompany>>): JSX.Element =>
      value ? <CompanyStatus company={value} /> : <></>,
  },
];

export const sortableColumns: ColumnDefinition<string>[] = [
  { name: 'companyName', label: 'Company Name', dataType: FilterSortDataType.TEXT },
  {
    name: 'lastChange',
    label: 'Last Change',
    dataType: FilterSortDataType.NUMBER,
  },
];
